import { builtInViews } from "@hq/core";
import { cn } from "@z/ui";
import { Layers } from "lucide-react";
import { QuickAdd } from "../QuickAdd";
import { TaskList } from "../TaskList";
import { ViewHeader } from "../ViewHeader";
import { type ViewProps, viewClassName } from "./shared";
import { useViewState } from "./useViewState";

export function AnytimeView({ onOpenTask, now, className }: ViewProps) {
  const s = useViewState(builtInViews.anytime);
  return (
    <div data-slot="anytime-view" className={cn(viewClassName, className)}>
      <ViewHeader
        mode={s.mode}
        onModeChange={s.setMode}
        title={
          <span className="inline-flex items-center gap-2">
            <Layers className="size-4 text-fg-muted" />
            Anytime
          </span>
        }
        sort={s.sort}
        onSortChange={s.setSort}
        tags={s.tags}
        onTagsChange={s.setTags}
        availableTags={s.hasTasks ? s.allTags : []}
        displayControls={s.hasTasks && s.mode === "list"}
        groupBy={s.groupBy}
        onGroupByChange={s.setGroupBy}
        showCompleted={s.showCompleted}
        onShowCompletedChange={s.setShowCompleted}
      />
      <TaskList
        view={s.view}
        mode={s.mode}
        onTagClick={s.toggleTag}
        quickAdd={<QuickAdd triaged {...(now ? { now } : {})} />}
        emptyTitle="Nothing ready to work on"
        emptyDescription="Actionable tasks appear here. Future plans stay in Upcoming and possibilities in Someday."
        {...(onOpenTask ? { onOpenTask } : {})}
        {...(now ? { now } : {})}
      />
    </div>
  );
}
